import * as React from 'react';

const styles = require('./label.css');

interface IProps {
  text: React.ReactNode;
}

export class Label extends React.PureComponent<IProps, object> {
  public render() {
    return (
      <div className={styles['label']}>
        <span className={styles['text']}>{this.props.text}</span>
        <div className={styles['content']}>{this.props.children}</div>
      </div>
    );
  }
}
